import { useForm, UseFormReturn } from "react-hook-form";
import MedintFormInterface from "../../../../services/medintInterfaces";
import dayjs from "dayjs";

export const useFormMedint = (): UseFormReturn<MedintFormInterface> => {
  return useForm<MedintFormInterface>({
    defaultValues: {
      medIntDettaglio: {},
      modaleStampaAgenda: {
        dallaData:  dayjs(),
        allaData: dayjs(),
        rifTelefono: false,
      },
      noteAggiuntive: "",
      agendeAttive: "0",
      medIntNuovaPrestazione: {},
      medIntCopiaMedico: {},
      medIntInserimentoMultiplo: {},
      medIntNuovoProgramma: {},
      medIntNuovaAgenda: {},
      medIntIndisponibilita: {
        dataInizio: "",
        dataFine: "",
        oraInizio: "",
        oraFine: "",
        note: "",
      },
    },
    mode: "onSubmit",
  });
};
